import React from 'react';

/**
 * Context for compliance violation error handling
 * Provides wrapApiCall and handleError functions to components
 */
export const ComplianceViolationContext = React.createContext(null);

export default ComplianceViolationContext;
